<template>
  <div class="language-switcher">
    <b-dropdown
      id="dropdown"
      :data-testing="dataTesting"
      class="language-switcher__dropdown"
      toggle-class="language-switcher__toggle"
      no-caret
    >
      <template #button-content>
        {{ formatLocale(current) }}
        <span class="language-switcher__caret" />
      </template>
      <b-dropdown-item
        v-for="(item, index) in availableLocales"
        :key="index"
        @click="onSelectLang(item)"
      >
        {{ formatLocale(item) }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

/**
 * Language switcher for changing the locale
 */
export default {
  name: 'LanguageSwitcher',
  components: {
    BDropdown,
    BDropdownItem
  },

  props: {
    /**
     * Array of selectable locales
     */
    locales: {
      type: Array,
      required: true
    },
    /**
     * currently selected locale
     */
    current: {
      type: String,
      required: true
    },
    /**
     * Variable for cypress testing
     */
    dataTesting: {
      type: String,
      default: null
    }
  },

  computed: {
    /**
     * Returns locales excluding the current one
     */
    availableLocales() {
      return this.locales.filter(locale => locale !== this.current);
    }
  },

  methods: {
    /**
     * Emit change event
     *
     * @method onSelectLang
     */
    onSelectLang(value) {
      this.$emit('change', value);
    },

    /**
     * Formats the locale to display in the language switcher
     *
     * @method formatLocale
     */
    formatLocale(locale) {
      return locale.includes('-') ? locale.split('-')[1] : locale;
    }
  }
};

</script>

<style lang="scss">
  @import './LanguageSwitcher';
</style>
